import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { SifenPayloadService } from './sifen-payload.service';

@Module({
  imports: [PrismaModule],
  providers: [SifenPayloadService],
  exports: [SifenPayloadService],
})
export class SifenPayloadModule {}
